module.exports = __webpack_public_path__ + "reg-2-icon.png?dac8e29d30410f9fe3f6fb42daefd89f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reg-2-icon.png
// module id = 203
// module chunks = 0